var map = {
	"./avatar.png": 7214,
	"./coding-background.jpg": 6346,
	"./coding-background.png": 7086,
	"./desk.jpg": 2178,
	"./facebook.svg": 1722,
	"./github.svg": 8043,
	"./letter.jpg": 5821,
	"./linkedin.svg": 6288,
	"./logo.svg": 3287,
	"./stickyNote.jpeg": 8617,
	"./twitter.svg": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5144;